<div class="user-account">
  <!-- Consent Management Section -->
  <div class="user-account__consent-section">
    <app-consent-management></app-consent-management>
  </div>
</div>